import React, { FC, memo } from 'react';
import { Input } from './styles';
import { Props } from './types';

const Radio: FC<Props> = ({ ...rest }) => <Input type="radio" {...rest} />;

export default memo(Radio);
